import React from "react";
import ChatComponent from "./ChatComponent";

const Chat = () => {
  return <ChatComponent />;
};

export default Chat;
